// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
}

*, *::before, *::after {
  box-sizing: border-box;

    font-family:
       'Roboto Variable', Roboto, Helvetica, Arial, sans-serif !important;
}

#ea11y-scanner-wizard-widget {
  height: 100vh;
  width: 100vw;

  position: fixed;
  top: 0;
  inset-inline-start: 0;
  z-index: 999999;

  display: flex;
  justify-content: flex-end;

  overflow-x: visible;
  overflow-y: scroll;
  pointer-events: none;
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/style.css"],"names":[],"mappings":"AAAA;EACE,SAAS;AACX;;AAEA;EACE,sBAAsB;;IAEpB;yEACqE;AACzE;;AAEA;EACE,aAAa;EACb,YAAY;;EAEZ,eAAe;EACf,MAAM;EACN,qBAAqB;EACrB,eAAe;;EAEf,aAAa;EACb,yBAAyB;;EAEzB,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;AACtB","sourcesContent":["body {\n  margin: 0;\n}\n\n*, *::before, *::after {\n  box-sizing: border-box;\n\n    font-family:\n       'Roboto Variable', Roboto, Helvetica, Arial, sans-serif !important;\n}\n\n#ea11y-scanner-wizard-widget {\n  height: 100vh;\n  width: 100vw;\n\n  position: fixed;\n  top: 0;\n  inset-inline-start: 0;\n  z-index: 999999;\n\n  display: flex;\n  justify-content: flex-end;\n\n  overflow-x: visible;\n  overflow-y: scroll;\n  pointer-events: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
